import { Component, OnInit, OnDestroy, DoCheck, HostListener, ViewChildren, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { Config } from '../../config/config';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RestDataService } from '../../service/rest-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { SnotifyService } from 'ng-snotify';
import * as $ from 'jquery';
import { SharedDataService } from '../../service/shared-data.service';
import { LocalstorageService } from '../../service/localstorage.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as moment from 'moment';
@Component({
  selector: 'app-create-page',
  templateUrl: './create-page.component.html',
  styleUrls: ['./create-page.component.scss']
})
export class CreatePageComponent implements OnInit, DoCheck, OnDestroy {
  pageType: string;
  private sub: Subscription;
  page: Page;
  sectionQuery = '';
  appSectionQuery = '';
  subsectionQuery = '';
  stockQuery = '';
  parentSeriesPageQuery = '';
  showSearchData = true;
  pageQuery = 'list';
  arrowkeyLocation = 0;
  sectionId = null;
  appSectionId = null;
  subsectionId = null;
  pagePresent = true;
  showSuggestionBox = false;
  subSectionSuggestion = [];
  valueChangeEvent = true;
  pageDesign = [];
  sectionSuggestion = [];
  appSectionSuggestion = [];
  alreadyUsed = false;
  filteredSectionSuggestion = [];
  filteredAppSectionSuggestion = [];
  filteredSubSectionSuggestion = [];
  filteredpageDesign = [];
  allSubSections = [];
  coverImageURL: string;
  coverImageName: string;
  subSection: string;
  insideSection = false;
  insideParentSerisePage = false;
  insideSubSection = false;
  insideAppSection = false;
  parantUrl: string;
  sectionUrl: string;
  subSectionUrl: string;
  disableButton: boolean;
  checkUrl: string;
  adminRole = false;
  invalidData = false;
  formData: FormData;
  tempURL: string;
  editionDateSelected = true;
  @ViewChildren('sectionInput') sectionField;
  @ViewChildren('appSectionInput') appSectionField;
  @ViewChildren('subsectionInput') subsectionField;
  @ViewChildren('designInput') designField;
  @ViewChildren('stockInput') stockField;
  @ViewChildren('parentSeriesPage') parentSeriesPageField;
  searchQuery: FormControl = new FormControl();
  urlValidation: FormControl = new FormControl();
  // searchsubQuery: FormControl = new FormControl();
  selectedFile: File = null;

  cropperImageUrl = {
    url: null,
    data: null
  };
  showCropper = false;
  templateTypes = [];
  templateType = null;
  agencySuggestion = [];
  agencyQuery = '';
  filteredAgencySuggestion = [];
  insideAgency = false;
  @ViewChild('agencyList', {static: false}) agencyList;
  currentSelection = 0;

  pickStoryImageLoad = false;
  croppingInProgress = false;
  imageType: any;
  sponsorImageName: string;
  sponsorImageURL: string;
  sponsorImageFlag: boolean = false;
  domainConfig: {};
  isUrlEditable: boolean;
  pagesDisabled = [];
  tagUrlEnabled: boolean;

  marketurlSuggestions = [];
  parentSeriesPageSuggestions = [];
  filteredMarketUrlSuggestions = [];
  filteredParentSeriesPage = [];
  todayDate:any;
  aliasQuery: any;
  constructor(
    private config: Config,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private restService: RestDataService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private localstorageService:LocalstorageService
  ) {
    this.page = {
      alias: null,
      url: null,
      title: null,
      name: null,
      parentSection: null,
      metadata: {},
      domainId: null,
      keywords: [],
      synonymsList:[],
      description: null,
      about: null,
      section: null,
      subSection: null,
      topic: null,
      status: 'CREATED',
      pageType: null,
      coverImage: null,
      imageCaption: null,
      sponsorImage: null,
      category: null,
      design: null,
      images: {},
      template: null,
      tagUrlEnabled: false,
      toBeAutobacklink: true,
      properNoun:false,
      editionDate: null,
      editionText: null,
      siTourId: null ,
      shortName: null,
      displayName: null,
      seriesId: [],
      seriesParent: null,
      pageContentEnabled: false
    };

    this.formData = {
      name: '',
      url: '',
      alias: '',
      parentSection: '',
      stockName: '',
      stockId: '',
      title: '',
      keywords: [],
      synonyms: [],
      description: '',
      coverImage: '',
      imageCaption: '',
      sponsorImage: '',
      design: '',
      images: {},
      tagUrlEnabled: false,
      marketTopicPage: false,
      toBeAutobacklink: true,
      properNoun:false,
      editionDate:'',
      editionText: '',
      siTourId: null,
      shortName: '',
      displayName: '',
      seriesId: [],
      seriesParent: null,
      pageContentEnabled: false
    };
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    // console.log(this.domain, this.domainConfig, conf);
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.pagesDisabled = this.domainConfig['pagesDisabled'] || [];
    this.tagUrlEnabled = this.domainConfig['config']['story']['tagUrlEnabled'];
  }

  ngOnInit() {
    this.todayDate = moment().format("YYYY-MM-DD");
    this.sub = this.route.params.subscribe((params: Params) => {
      this.pageType = params['type'];
      if (this.pagesDisabled.indexOf(params['type']) > -1) {
        this.snotify.error(params['type'] + ' Page is not enabled for this domain', '', this.sharedService.getConfig(false));
        this.resetForm();
      }
    });
    if (this.pageType === 'SUBSECTION_L2') {
      this.getSectionList();
      this.getSubSection();
      this.checkUrl = 'subsection';
    } else if(this.pageType === 'SERIES'){
      this.getParentSuggetionsList();
    }
     else if (this.pageType === 'SUBSECTION' || this.pageType === 'TOPIC') {
      this.getSectionList();
      this.checkUrl = 'subsection';

      if(this.pageType === 'TOPIC' && this.domainConfig['config']['pages']['topicStockUrl'])
        this.getMarketTopicsList();

    } if (this.pageType === 'APP_SUBSECTION') {
      this.getAppSectionList();
      this.checkUrl = 'subsection';
    } else {
      this.checkUrl = '';
    }
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role!=='ROLE_SITE_MANAGER') {
      this.snotify.error('You do not have permissions to create a page', '', this.sharedService.getConfig(false));
      this.adminRole = false;
    } else {
      this.adminRole = true;
    }
    this.getStoryMetaList();
    this.getDesignList();
    this.getTemplateList();
    if (this.searchQuery) {
      this.searchQuery.valueChanges
        .pipe(debounceTime(200)
        ,distinctUntilChanged())
        .subscribe(result => {
          if(!this.onKeyupAlias(null))
          {
          if (this.pageType === 'AGENCY') {
            this.isSectionExists(this.agencyQuery, '', data => {
              if (data && data['content'] && data['content'].length > 0) {
                this.pagePresent = true;
                this.alreadyUsed = true;
              } else {
                this.pagePresent = false;
                this.alreadyUsed = false;
              }
              this.parantUrl = '/agency/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
              this.formData.url = this.parantUrl;
              this.formData.marketTopicPage = false;
            });
          } else {
            if(this.pageType === 'APP_SECTION') {
              console.log("value changes");
              this.formData.url = '/app-' + this.formData.alias.replace(/ /g, '-').toLowerCase();
            }
            else if(this.pageType === 'BRUNCH'){
               //do Nothing handled in validateEditionDate() method
            }else if(this.pageType === 'TOPIC'){
              this.formData.url = '/topic/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
            } else if (this.pageType === 'SUBSECTION') {
              if (this.sectionUrl && this.formData.alias === "") {
                this.formData.url = '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
              }
              else if (this.sectionUrl)
                this.formData.url = this.sectionUrl + '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
              else
                this.formData.url = '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
            }
            else if (this.pageType === 'SUBSECTION_L2') {
              if (this.subSectionUrl && this.formData.alias === "") {
                this.formData.url = '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
              }
              else if (this.subSectionUrl)
                this.formData.url = this.subSectionUrl + '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
              else
                this.formData.url = '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
            }
             else {
              this.formData.url = '/' + this.formData.alias.trim().replace(/ /g, '-').toLowerCase();
            }
            this.formData.marketTopicPage = false;
            if(this.pageType ==='SUBSECTION' || this.pageType === 'SUBSECTION_L2'|| this.pageType === 'TOPIC'){
              if(this.sectionQuery && this.sectionQuery.length > 0){
                this.isSectionExists('/' + result, this.checkUrl, data => {
                  if (data && data['content'] &&data['content'].length > 0) {
                    this.pagePresent = true;
                    this.alreadyUsed = true;
                  } else {
                    this.pagePresent = false;
                    this.alreadyUsed = false;
                  }
                });
              }else{
                this.disableButton = true;
              }
            }
            else{
              this.isSectionExists('/' + result, this.checkUrl, data => {
                if (data && data['content'] &&data['content'].length > 0) {
                  this.pagePresent = true;
                  this.alreadyUsed = true;
                } else {
                  this.pagePresent = false;
                  this.alreadyUsed = false;
                }
              });
            }

          }
        }
        });
    } else {
      this.pagePresent = true;
      this.alreadyUsed = true;
    }
    if(this.urlValidation){
      this.urlValidation.valueChanges
      .pipe(debounceTime(200)
      ,distinctUntilChanged())
      .subscribe(result => {
        if (this.pageType === 'AGENCY') {
        } else {
          this.isSectionExists(result, this.checkUrl, data => {
            if (data && data['content'] && data['content'].length > 0) {
              this.pagePresent = true;
              this.alreadyUsed = true;
            } else {
              this.pagePresent = false;
              this.alreadyUsed = false;
            }
          });
        }
      });
    }
    this.sponsorImageFlag = this.sharedService.isdomainConfig('pages','sponsorImage');
    this.isUrlEditable = this.sharedService.isdomainConfig('pages','editUrl');
  }

  @HostListener('window:keydown', ['$event'])
  public hotkeys($event) {
    const key = $event.keyCode || $event.charCode;
    if (key === 27) {
      if (this.showCropper) {
        this.cancelCropping();
      } else {
        this.resetForm();
      }
    }
  }

  onFileChange(event,imageType) {
    this.imageType=imageType;
    const reader: FileReader = new FileReader();
    this.selectedFile = <File>event.target.files[0];
    if (event.target.files && event.target.files.length > 0) {
      if ((typeof event.target.files[0]) === 'object') {
        if ((this.selectedFile.size / 1000000) <= 11) {
          const a = reader.readAsDataURL(event.target.files[0]);
          reader.onload = (e: any) => {
            if(imageType === 'coverImage'){
              this.coverImageName = this.selectedFile.name;
            }
            if(imageType === 'sponsorImage'){
              this.sponsorImageName = this.selectedFile.name;
            }
            this.openCropper(e.target.result);
          };
        } else {
          this.selectedFile = null;
          this.coverImageName = null;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
    }
  }

  openCropper(data) {
    this.pickStoryImageLoad = true;
    const fd = new FormData();
    fd.set('file', this.selectedFile, this.selectedFile.name);
    fd.append('removeLowQualityRestriction','true');
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
      subscribe(res => {
        this.cropperImageUrl.url = res['images']['original'];
        this.cropperImageUrl.data = data;
        this.showCropper = true;
      },
        err => {
          this.croppingInProgress = false;
          this.selectedFile = null;
          this.imageType = "";
          this.pickStoryImageLoad = false;
          this.snotify.error(err.error.errorMessage ?err.error.errorMessage : 'Could not upload image' , '', this.sharedService.getConfig(false));
        });
  }

  cancelCropping() {
    this.showCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null
    };
    this.selectedFile = null;
    this.imageType = "";
    this.pickStoryImageLoad = false;
  }

  finishCropping(event, imageType) {
    const requests = event.cropRequests;
    this.cancelCropping();
    this.croppingInProgress = true;
    this.sharedService.croppingSequence(requests, false, data => {
      this.croppingInProgress = false;
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        if(imageType === 'coverImage'){
        this.formData.images = imagemap;
        if(this.pageType === 'BRUNCH'){
          this.coverImageURL = JSON.stringify(imagemap['original'] || '').replace(/"/gi, '');
          this.formData.coverImage = JSON.stringify(imagemap['original'] || '').replace(/"/gi, '');
        }
        else{
        this.coverImageURL = JSON.stringify(imagemap['960x540'] || '').replace(/"/gi, '');
        this.formData.coverImage = JSON.stringify(imagemap['960x540'] || '').replace(/"/gi, '');
      }
        }
        if(imageType === 'sponsorImage'){
          this.sponsorImageURL = JSON.stringify(imagemap['960x540'] || '').replace(/"/gi, '');
          this.formData.sponsorImage = JSON.stringify(imagemap['960x540'] || '').replace(/"/gi, '');
          }
        this.selectedFile = null;
      } else {
        console.log(data);
      }
    });
  }

  resetForm() {
    this.formData = {
      name: '',
      parentSection: '',
      stockName: '',
      stockId: '',
      alias: '',
      url: '',
      title: '',
      keywords: [],
      synonyms: [],
      description: '',
      sponsorImage:'',
      coverImage: '',
      imageCaption:'',
      design: '',
      images: {},
      tagUrlEnabled: false,
      marketTopicPage: false,
      toBeAutobacklink: true,
      properNoun: false,
      editionDate: '',
      editionText: '',
      siTourId: null,
      shortName: '',
      displayName: '',
      seriesId: [],
      seriesParent: null,
      pageContentEnabled: false
    };
    this.router.navigate(['/dash/pages']);
  }

  toggleSwitch(type){
    if(type === 'autobacklink'){
      this.formData.toBeAutobacklink= !this.formData.toBeAutobacklink;
    }
    if(type === 'propernoun'){
      this.formData.properNoun= !this.formData.properNoun;
    }
    if(type == 'pageContent'){
      this.formData.pageContentEnabled = !this.formData.pageContentEnabled;
    }
  }

  savePage() {
    if (this.page.design === 'template') {
      if (this.templateType !== null) {
        this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/template/' + this.templateType.id)
          .subscribe(
            data => {
              this.page.template = data;
              this.page.title = this.formData.title.toLowerCase();
              this.page.pageType = this.pageType;
              this.page.coverImage = this.formData.coverImage;
              this.page.imageCaption = this.formData.imageCaption;
              this.page.sponsorImage =this.formData.sponsorImage;
              this.page.images = this.formData.images;
              this.page.synonymsList = this.formData.synonyms;
              this.page.metadata.marketStockName = this.formData.stockName;
              this.page.metadata.marketStockId = this.formData.stockId;
              this.page.metadata.marketTopicPage = this.formData.marketTopicPage;
              this.page.toBeAutobacklink = this.formData.toBeAutobacklink;
              this.page.pageContentEnabled = this.formData.pageContentEnabled;
              this.page.properNoun = this.formData.properNoun;
              if(this.pageType === 'BRUNCH'){
                let date = moment.utc(moment(this.formData.editionDate).utc()).format();
                this.page.editionDate = date.replace('Z', '+0000')
                this.page.editionText = this.formData.editionText
              }
              if(this.formData.url[0] !== "/") {
                this.formData.url = "/"+this.formData.url;
              }
              this.page.url = this.formData.url;
              this.page.name = this.formData.name;
              this.page.design = this.pageQuery;
              //this.page.alias = this.formData.alias;
              this.page.alias = this.formData.alias.trim();
              if ((this.sectionId) && (this.pageType === 'SUBSECTION_L2' || this.pageType === 'SUBSECTION' || this.pageType === 'TOPIC')) {
                this.page.parentSection = { 'id': this.sectionId };
              } else if ((this.sectionId) && (this.pageType === 'APP_SUBSECTION')) {
                this.page.parentSection = { 'id': this.appSectionId };
              }else {
                this.page.parentSection = null;
              }
              this.page.keywords = this.formData.keywords;
              this.page.description = this.formData.description;
              if (this.page.parentSection || this.pageType=== 'BRUNCH' || this.pageType === 'SECTION' || this.pageType === 'PRIMARY' || this.pageType === 'AGENCY' || this.pageType === 'COMPANY' || this.pageType === 'APP_SECTION') {
                this.restService.http_post(this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'pages', 'save_page')
                  , this.page, result => {
                    if (result && result.id) {
                      this.router.navigate(['/dash/page/' + result.id]);
                    }
                  });
              } else {
                this.snotify.error('Please enter section', '', this.sharedService.getConfig(false));
              }
            },
            err => {
              console.log(err);
            }
          );
      } else {
        this.snotify.error('Please select template type', '', this.sharedService.getConfig(false));
      }
    } else {

      this.page.title = this.formData.title.toLowerCase();
      this.page.pageType = this.pageType;
      this.page.coverImage = this.formData.coverImage;
      this.page.imageCaption = this.formData.imageCaption;
      this.page.sponsorImage = this.formData.sponsorImage;
      this.page.images = this.formData.images;
      this.page.metadata.marketStockName = this.formData.stockName;
      this.page.metadata.marketStockId = this.formData.stockId;
      this.page.metadata.marketTopicPage = this.formData.marketTopicPage;
      this.page.toBeAutobacklink = this.formData.toBeAutobacklink;
      this.page.pageContentEnabled = this.formData.pageContentEnabled;
      this.page.properNoun = this.formData.properNoun;
      if(this.formData.url[0] !== "/") {
        this.formData.url = "/"+this.formData.url;
      }
      this.page.url = this.formData.url;
      this.page.name = this.formData.name;
      this.page.design = this.pageQuery;
      this.page.seriesParent = this.formData.seriesParent?this.formData.seriesParent:null;
      this.page.siTourId = this.formData.siTourId
      this.page.shortName = this.formData.shortName
      this.page.displayName = this.formData.displayName
      this.page.seriesId = this.formData.seriesId
      if(this.pageType === 'APP_SECTION' || this.pageType === 'APP_SUBSECTION') {
        //this.page.alias = 'app ' + this.formData.alias;
        this.page.alias = 'app ' + this.formData.alias.trim();
      } else {
        //this.page.alias = this.formData.alias;
        this.page.alias = this.formData.alias.trim();
      }
      if ((this.sectionId) && (this.pageType === 'SUBSECTION_L2' || this.pageType === 'SUBSECTION' || this.pageType === 'TOPIC')) {
        this.page.parentSection = { 'id': this.sectionId };
      } else if ((this.sectionId) && (this.pageType === 'APP_SUBSECTION')) {
        this.page.parentSection = { 'id': this.appSectionId };
      } else {
        this.page.parentSection = null;
      }
      this.page.keywords = this.formData.keywords;
      console.log(this.formData.synonyms)
      this.page.synonymsList = this.formData.synonyms;
      this.page.description = this.formData.description;
      if(this.pageType === 'BRUNCH'){
        let date = moment.utc(moment(this.formData.editionDate).utc()).format();
        this.page.editionDate = date.replace('Z', '+0000')
        this.page.editionText = this.formData.editionText
      }
      this.page.tagUrlEnabled = this.formData.tagUrlEnabled;
      if (this.page.parentSection || this.pageType=== 'BRUNCH' ||this.pageType === 'SECTION' || this.pageType === 'PRIMARY' || this.pageType === 'AGENCY' || this.pageType === 'COMPANY' || this.pageType === 'APP_SECTION' || this.pageType === 'SERIES') {
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'pages', 'save_page')
          , this.page, result => {
            if (result && result.id) {
              this.router.navigate(['/dash/page/' + result.id]);
            }
            else if(result.hasOwnProperty('error')){
              this.snotify.error(result.error,'Error',this.sharedService.getConfig(false));
            }
          });
      } else {
        this.snotify.error('Please enter section', '', this.sharedService.getConfig(false));
      }
    }
  }

  filterAutoComplete(type) {
    if (this.showSearchData) {
      if (type === 'section') {
        if (this.insideSection) {
          if (this.sectionQuery && this.sectionQuery.length > 0) {
            this.filteredSectionSuggestion = this.sectionSuggestion.filter(function (el) {
              return el.value.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredSectionSuggestion = this.sectionSuggestion;
          }
        }
      } else if (type === 'parentSeriesPage') {
        if (this.insideParentSerisePage) {
          if (this.parentSeriesPageQuery && this.parentSeriesPageQuery.length > 0) {
            this.filteredParentSeriesPage = this.sectionSuggestion.filter(function (el) {
              return el.value.toLowerCase().indexOf(this.parentSeriesPageQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredParentSeriesPage = this.parentSeriesPageSuggestions;
          }
        }
      }else if (type === 'appSection') {
        if (this.insideAppSection) {
          if (this.appSectionQuery && this.appSectionQuery.length > 0) {
            this.filteredAppSectionSuggestion = this.appSectionSuggestion.filter(function (el) {
              return el.value.toLowerCase().indexOf(this.appSectionQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.filteredAppSectionSuggestion = this.appSectionSuggestion;
          }
        }
      } else if (type === 'subsection') {
        if (this.subsectionQuery && this.subsectionQuery.length > 0) {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion.filter(function (el) {
            return el.value.toLowerCase().indexOf(this.subsectionQuery.toLowerCase()) > -1;
          }.bind(this));
        } else {
          if(this.pageType==='SUBSECTION_L2') {
            this.disableButton=true;
          }
          this.filteredSubSectionSuggestion = this.subSectionSuggestion;
        }
      } else if (type === 'stock') {
        if (this.stockQuery && this.stockQuery.length > 0) {
          this.filteredMarketUrlSuggestions = this.marketurlSuggestions.filter(function (el) {
            return el.name.toLowerCase().indexOf(this.stockQuery.toLowerCase()) > -1;
          }.bind(this));
        } else {
          this.filteredMarketUrlSuggestions = this.marketurlSuggestions;
          if(this.sectionQuery && this.sectionQuery.length > 0) {
            if(this.tagUrlEnabled) {
              this.parantUrl = '/tags/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
              this.formData.url = this.parantUrl;
              this.formData.tagUrlEnabled = this.tagUrlEnabled;
            } else {
              this.parantUrl = '/topic/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
              this.formData.url = this.parantUrl;
            }
          } else {
            this.formData.url = '';
            this.parantUrl = '';
          }
          this.formData.marketTopicPage = false;
          this.formData.stockId = '';
          this.formData.stockName = '';
        }
      } else {
        this.filteredpageDesign = this.pageDesign;
      }
    }
  }
  filterAutoCompleteSection(type){
    if (this.showSearchData) {
      if (type === 'section') {
          if (this.sectionQuery && this.sectionQuery.length > 0) {
            this.filteredSectionSuggestion = this.sectionSuggestion.filter(function (el) {
              return el.value.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            if(this.pageType ==='SUBSECTION' || this.pageType === 'TOPIC'){
              this.disableButton = true;
            }
            this.filteredSectionSuggestion = this.sectionSuggestion;
          }
      }
    }
  }
  getSectionList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/section/all')
      .subscribe(
        data => {
          this.dataInsertion(data, 'Section');
        },
        err => {
          console.log(err);
        }
      );
  }
  getAppSectionList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/app-section/all')
      .subscribe(
        data => {
          this.dataInsertion(data, 'AppSection');
        },
        err => {
          console.log(err);
        }
      );
  }
  getSubSection() {
    let url = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'pages', 'search_pages')
      + '?size=500&page=0';
    url += '&search=pageType:SUBSECTION';
    this.restService.http_get(url)
      .subscribe(
        data => {
          this.dataInsertion(data['content'], 'SubSection');
        },
        err => {
          console.log(err);
        }
      );
  }

  getMarketTopicsList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/topic/market/all')
      .subscribe(
        data => {
          this.marketurlSuggestions = data;
        },
        err => {
          console.log(err);
        }
      );
  }

  getParentSuggetionsList(){
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/series/parent')
    .subscribe(
      data => {
        console.log("test",data)
        this.parentSeriesPageSuggestions = data;
      },
      err => {
        console.log(err);
      }
    );
  }

  selectAutoCompletePage(item) {
    this.pageQuery = item.value;
    this.page.design = this.pageQuery;
    this.filteredpageDesign = [];
  }

  selectAutoComplete(item, itemPageType) {
    console.log(this.parantUrl + " " + item + " " + itemPageType);
    if (itemPageType === 'SUBSECTION'|| itemPageType === 'TOPIC' || itemPageType === 'AGENCY' || itemPageType === 'APP_SUBSECTION') {
      console.log(this.parantUrl);
      if(this.parantUrl == undefined || this.parantUrl.trim().length < 1){
        if (itemPageType === 'TOPIC' ) {
          if(this.tagUrlEnabled) {
            this.parantUrl = '/tags/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
            this.formData.url = this.parantUrl;
            this.formData.tagUrlEnabled = this.tagUrlEnabled;
          } else {
            this.parantUrl = '/topic/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
            this.formData.url = this.parantUrl;
          }
        } else if (itemPageType === 'APP_SUBSECTION' ) {
            console.log("changes value", JSON.stringify(item));
            this.parantUrl = item.url + '/app-' + this.formData.alias.replace(/ /g, '-').toLowerCase();
            this.formData.url = this.parantUrl;
            this.appSectionQuery = item.value;
            this.appSectionId = item.id;
            this.filteredAppSectionSuggestion = [];
        } else {
          this.sectionUrl = item.url;
          this.parantUrl = item.url + '/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
          this.formData.url = this.parantUrl;
        }
        this.formData.marketTopicPage = false;
      }

      this.isSectionExists(this.parantUrl, '', data => {
        if (data && data['content'] && data['content'].length > 0) {
          this.pagePresent = true;
          this.alreadyUsed = true;
        } else {
          this.pagePresent = false;
          this.alreadyUsed = false;
        }
      });
      this.sectionQuery = item.value;
      this.sectionId = item.id;
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
    } else {
      if (itemPageType === 'APP_SECTION') {
        console.log("in app section");
        if (this.parantUrl == undefined || this.parantUrl.trim().length < 1) {
          this.parantUrl = '/app-' + this.formData.alias.replace(/ /g, '-').toLowerCase();
          this.formData.url = this.parantUrl;
        }

      this.appSectionId = item.id;
      this.appSectionQuery = item.value;
      }
      if (itemPageType === 'SUBSECTION_L2' && this.allSubSections) {
        this.subsectionQuery = '';
        this.subsectionId = null;
        this.parantUrl = '/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
        this.formData.url = this.parantUrl;
        this.filteredSubSectionSuggestion = [];
        this.subSectionSuggestion = [];
        for (let i = 0; i < this.allSubSections.length; i++) {
          if (this.allSubSections[i].url.indexOf(item.url + '/') == 0) {
            this.filteredSubSectionSuggestion.push(this.allSubSections[i]);
            this.subSectionSuggestion.push(this.allSubSections[i]);
          }
        }
      }
      this.sectionQuery = item.value;
      this.sectionId = item.id;
      this.filteredSectionSuggestion = [];
    }
    this.parantUrl = "";
  }
  selectAutoCompleteSubsectionL2(item, itemPageType) {
    if (itemPageType =='SUBSECTION_L2') {
      if(this.parantUrl == undefined || this.parantUrl.trim().length < 1){

        if (itemPageType === 'TOPIC' ) {
          if(this.tagUrlEnabled) {
            this.parantUrl = '/tags/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
            this.formData.url = this.parantUrl;
            this.formData.tagUrlEnabled = this.tagUrlEnabled;
          } else {
            this.parantUrl = '/topic/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
            this.formData.url = this.parantUrl;
          }
        } else {
          this.subSectionUrl = item.url;
          this.parantUrl = item.url + '/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
          this.formData.url = this.parantUrl;
          this.subsectionId = item.id;
          for(let i=0;i<this.sectionSuggestion.length;i++)
          {
            if (item.url.indexOf(this.sectionSuggestion[i].url + '/') == 0) {
              this.sectionQuery = this.sectionSuggestion[i].value;
            }
          }
        }

        this.formData.marketTopicPage = false;

      } else {
        this.subSectionUrl = item.url;
        this.parantUrl = item.url + '/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
        this.formData.url = this.parantUrl;
        this.subsectionId = item.id;
      }

      this.isSectionExists(this.parantUrl, '', data => {
        if (data && data['content'] && data['content'].length > 0) {
          this.pagePresent = true;
          this.alreadyUsed = true;
        } else {
          this.pagePresent = false;
          this.alreadyUsed = false;
        }
      });
      this.subsectionQuery = item.value;
      this.sectionId = item.id;
      this.filteredSectionSuggestion = [];
      // this.filteredSubSectionSuggestion = [];
      this.insideSubSection = false;
    } else {
      this.subsectionQuery = item.value;
      this.sectionId = item.id;
      this.filteredSectionSuggestion = [];
    }
  }

  selectMarketStock(item) {
    this.parantUrl = item.url;
    this.formData.url = this.parantUrl;
    this.stockQuery = item.name;
    this.formData.stockName = this.stockQuery;
    this.formData.stockId = item.stockId;
    this.formData.marketTopicPage = true;
    this.filteredMarketUrlSuggestions = [];
  }

  selectParentSeriesPage(item){
    this.parentSeriesPageQuery = item.name;
    this.formData.seriesParent = item;
    this.filteredParentSeriesPage = [];
  }

  ngDoCheck() {
    if (this.pageType === 'SECTION' || this.pageType === 'PRIMARY' || this.pageType === 'COMPANY') {
      // this.formData.url = '/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
    } else {
      // if (this.parantUrl) {
      //   this.formData.url = this.parantUrl + '/' + this.formData.name.replace(/ /g, '-').toLowerCase();
      // } else {
      //   this.formData.url = '';
      //  // this.pagePresent = false;
      // }
      /* if (!this.tempURL) {
        this.formData.url = '/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
      } else {
        this.formData.url = '/' + this.tempURL.toLowerCase();
      } */
    }
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
    if (this.sectionField['_results'][0] && clickedComponent === this.sectionField['_results'][0].nativeElement) {
      this.insideSection = true;
      this.insideSubSection = false;
      if (this.sectionQuery === '') {
        this.filteredSectionSuggestion = this.sectionSuggestion;
      }
    } else if (this.appSectionField['_results'][0] && clickedComponent === this.appSectionField['_results'][0].nativeElement) {
      this.insideAppSection = true;
      if (this.appSectionQuery === '') {
        this.filteredAppSectionSuggestion = this.appSectionSuggestion;
      }
    } else if (this.stockField['_results'][0] && clickedComponent === this.stockField['_results'][0].nativeElement) {
      this.insideSection = false;
      if (this.stockQuery === '') {
        this.filteredMarketUrlSuggestions = this.marketurlSuggestions;
      }
    } else if (this.parentSeriesPageField['_results'][0] && clickedComponent === this.parentSeriesPageField['_results'][0].nativeElement) {
      this.insideParentSerisePage = true;
      if (this.parentSeriesPageQuery === '') {
        this.filteredParentSeriesPage = this.parentSeriesPageSuggestions;
      }
    } else if (this.subsectionField['_results'][0] && clickedComponent === this.subsectionField['_results'][0].nativeElement) {
      this.insideSection = false;
      this.insideSubSection = true;
      if (this.subsectionQuery === '') {
        if(this.sectionQuery === '')
        {
          this.subSectionSuggestion = this.allSubSections;
          this.filteredSubSectionSuggestion = this.allSubSections;
        }
      } else {
        this.filteredSubSectionSuggestion = this.subSectionSuggestion.filter(function (el) {
          return el.value.toLowerCase().indexOf(this.subsectionQuery.toLowerCase()) > -1;
        }.bind(this));
      }
    } else if (this.designField['_results'][0] && clickedComponent === this.designField['_results'][0].nativeElement) {
      this.insideSection = false;
    } else {
      this.insideSection = false;
      this.insideParentSerisePage = false;
      this.filteredSectionSuggestion = [];
      // this.filteredSubSectionSuggestion = [];
      this.insideSubSection = false;
      this.filteredpageDesign = [];
      this.filteredMarketUrlSuggestions = [];
      this.filteredParentSeriesPage = [];
    }

  }

  dataInsertion(data, pageType) {
    if (pageType === 'SubSection') {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id !== null) {
          this.subSectionSuggestion.push(
            {
              'id': data[i].id,
              'value': data[i].name,
              'url': data[i].url
            }
          );
          this.allSubSections.push(
            {
              'id': data[i].id,
              'value': data[i].name,
              'url': data[i].url
            }
          );
        }
      }
    }
    else if (pageType === 'Section') {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id !== null) {
          this.sectionSuggestion.push(
            {
              'id': data[i].id,
              'value': data[i].name,
              'url': data[i].url
            }
          );
        }
      }
    }
    else if (pageType === 'AppSection') {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id !== null) {
          this.appSectionSuggestion.push(
            {
              'id': data[i].id,
              'value': data[i].name,
              'url': data[i].url
            }
          );
        }
      }
    }
  }

  validateEditionDate(){
    this.formData.url = "";
    this.formData.alias = "";
    this.formData.name = "";
    if(this.formData.editionDate) {
      this.editionDateSelected = false
    }
    if(this.pageType === 'BRUNCH' && this.formData.editionDate){
      const formattedDate = this.sharedService.formatDate(this.formData.editionDate);
      this.formData.url =  '/brunch-edition-' + formattedDate;
      // this.formData.alias = 'brunch-edition-' +formattedDate;
      this.formData.alias = 'brunch edition ' + formattedDate.replace(/-/g, ' ');
      this.formData.name = 'Brunch Edition ' +formattedDate.replace(/-/g, ' ');
    }
  }

  isSectionExists(query: string, pageType, callback) {
    if(this.pageType === 'SUBSECTION' || this.pageType === 'TOPIC' || this.pageType === 'SUBSECTION_L2'){
      if(query === '/'){
        this.sectionUrl = '';
        this.sectionQuery = '';
        this.subSectionUrl = '';
        this.subsectionQuery = '';
      }
    }
    if (query === '/') {
      this.disableButton = true;
      this.invalidData = false;
    }
    const pattern = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    if (query) {
      let temp = query.substring(1);
      const regex = /[^a-z\d\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/i;
      if (regex.test(temp)) {
        this.invalidData = true;
        this.disableButton = true;
        return;
      }
      for (let i = 0; i < temp.length; i++) {
        if (pattern.test(temp.charAt(i))) {
          this.tempURL = temp.replace(temp.charAt(i), '');
          temp = this.tempURL;
          i--;
        }
      }
      const pattern1 = /[^a-z\d\s]/i;
      if (!pattern1.test(temp)) {
        this.tempURL = temp;
        if (temp !== '') {
          this.pagePresent = false;
          this.disableButton = false;
        } else {
          this.pagePresent = true;
          this.disableButton = true;
        }
      }
    }

    if (!pageType) {
      this.valueChangeEvent = true;
      this.invalidData = false;
      this.disableButton = false;
    }
    if (pageType) {
      this.sectionQuery = '';
      /*   this.alreadyUsed = false;
        this.invalidData = true;
        this.disableButton = false; */
      this.pagePresent = true;
      this.formData.url = '';
      this.stockQuery = '';

      this.formData.marketTopicPage = false;
    } else {
      if (query) {
        let query1: any = query.split(' ');
        query1 = query1[(query1.length - 1)];
        if (query1 && query1.length > 2 && this.valueChangeEvent) {
          let url = this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'pages', 'search_pages');
          if (this.pageType === 'AGENCY') {
            url += '?search=name:' + query + ',pageType:AGENCY';
          } else {
            if(this.pageType === 'APP_SECTION') {
              console.log(query);
              url += '?search=url:/app-' + query.substring(1).replace(/ /g, '-').trim().toLowerCase();
            } else {
              url += '?search=url:' + query.replace(/ /g, '-').trim().toLowerCase();
            }
          }
          url += ',domainId:' + sessionStorage.getItem(StaticDataService.domainLiteral);
          this.restService.http_get(url).subscribe(
            data => {
              callback(data);
              if (pageType && this.showSuggestionBox) {
                this.showSuggestionBox = false;
                this.valueChangeEvent = false;
              } else {
                this.valueChangeEvent = true;
              }
            },
            err => {
              console.log(err);
            }
          );
        } else {
          this.valueChangeEvent = true;
        }
      } else {
        this.pagePresent = true;
      }
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  getTemplateList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/meta')
      .subscribe(
        data => {
          this.templateTypes = data['templates'];
        },
        err => {
          console.log(err);
        }
      );
  }
  getDesignList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/design/all')
      .subscribe(
        data => {
          this.pageDataInsertion(data);
        },
        err => {
          console.log(err);
        }
      );
  }
  pageDataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.pageDesign.push({ 'value': data[i] });
      }
    }
  }

  onKeyupAlias($event) {
    console.log(this.formData.alias)
    return this.checkSpecialChars(this.formData.alias);
  }

  checkSpecialChars(stringName) {
    //let regex = new RegExp(/[^a-zA-z0-9-_.\s]+/g);
    let regex = new RegExp(/[^a-zA-Z0-9 ]+/g);
    let m;
    m = regex.exec(stringName);
    if (m) {
        stringName = stringName.replace(regex, '');
        console.log("rejected => ", stringName)
        this.snotify.error('Special Chars not Allowed in uploaded image', '', this.sharedService.getConfig(false));
        this.formData.alias = stringName;
        return true;
    }
    return  false;
  }

  onKeydown(event) {
    if (event.keyCode === 40 && this.arrowkeyLocation < this.filteredSectionSuggestion.length - 1) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation++;
      this.sectionQuery = this.filteredSectionSuggestion[this.arrowkeyLocation].value;
      this.showSearchData = false;
    } else if (event.keyCode === 38 && this.arrowkeyLocation > 0) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation--;
      this.sectionQuery = this.filteredSectionSuggestion[this.arrowkeyLocation].value;
      this.showSearchData = false;
    } else {
      this.valueChangeEvent = true;
      this.showSearchData = true;
      this.arrowkeyLocation = 0;
      this.showSuggestionBox = false;
    }
    return true;
  }


  filterAutoCompleteUp(event, model) {
    // console.log(event);
    // console.log(model);
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
      if (model === 'agency') {
        if (this.insideAgency) {
          if (this.agencyQuery && this.agencyQuery.length > 0) {
            this.filteredAgencySuggestion = this.agencySuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.agencyQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.formData.name = '';
            this.agencyQuery = '';
            this.filteredAgencySuggestion = this.agencySuggestion;
          }
        } else {
          this.insideAgency = true;
          this.filteredAgencySuggestion = [];
        }
      }
    }
    // this.currentSelection = 0;
    return true;
  }

  filterAutoCompleteDown(event, model) {
    if (event.key === 'Enter') {
      if (model === 'agency') {
        this.insideAgency = false;
        this.selectAutoCompleteMeta(model, this.filteredAgencySuggestion[this.currentSelection]);
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'agency') {
        if (this.currentSelection < (this.filteredAgencySuggestion.length - 1)) {
          this.currentSelection += 1;
          this.agencyList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideAgency = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'agency') {
          this.agencyList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      // console.log('tab on ' + model);
      if (this.insideAgency) {
        this.focusOutSuggest(model);
      }
    } else {
      this.currentSelection = 0;
    }
    // console.log(this.currentSelection);
    return true;
  }

  focusInSuggest(model) {
    if (model === 'agency') {
      this.insideAgency = true;
      if (this.agencyQuery === '') {
        this.filteredAgencySuggestion = this.agencySuggestion;
      }
    }
    this.currentSelection = 0;
    this.filterAutoCompleteUp({ keyCode: 0 }, model);
  }

  focusOutSuggest(model) {
    if (model === 'agency') {
      this.insideAgency = false;
      this.filteredAgencySuggestion = [];
    }
    this.currentSelection = 0;
  }

  selectAutoCompleteMeta(model, item) {
    if (model === 'agency') {
      this.agencyQuery = item;
      this.formData.name = item;
      this.focusOutSuggest(model);
      this.isSectionExists(item, '', data => {
        if (data && data['content'] && data['content'].length > 0) {
          this.pagePresent = true;
          this.alreadyUsed = true;
        } else {
          this.pagePresent = false;
          this.alreadyUsed = false;
          this.parantUrl = '/agency/' + this.formData.alias.replace(/ /g, '-').toLowerCase();
          this.formData.url = this.parantUrl;
        }
      });
    }
  }

  getStoryMetaList() {
    let data=this.localstorageService.getSuggestionData();
    // this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/suggestions')
    //   .subscribe(
    //     data => {
          if (data.hasOwnProperty('agencyNames')) {
            this.agencySuggestion = data['agencyNames'];
          }
      //   },
      //   err => {
      //     // console.log(err);
      //   }
      // );
  }

}

interface Page {
  url: string;
  alias: string;
  title: string;
  name: string;
  parentSection: {};
  metadata: any;
  domainId: string;
  keywords: any[];
  description: string;
  about: string;
  section: string;
  subSection: string;
  topic: string;
  status: string;
  synonymsList: any[];
  pageType: string;
  coverImage: string;
  imageCaption: string;
  sponsorImage: string;
  category: string;
  design: string;
  images: any;
  template: any;
  tagUrlEnabled: boolean;
  toBeAutobacklink: boolean;
  properNoun:boolean;
  editionDate: any;
  editionText: string;
  siTourId: any;
  shortName: string;
  displayName: string,
  seriesId: any[];
  seriesParent: any;
  pageContentEnabled: boolean
}
interface FormData {
  name: string;
  parentSection: string;
  stockName: string;
  stockId: string;
  alias: string;
  url: string;
  title: string;
  keywords: any[];
  synonyms: any[];
  description: string;
  coverImage: string;
  imageCaption: string;
  design: string;
  images: any;
  sponsorImage: string;
  tagUrlEnabled: boolean;
  marketTopicPage: boolean;
  toBeAutobacklink: boolean;
  properNoun: boolean;
  editionDate: any;
  editionText: string;
  siTourId: string;
  shortName: string;
  displayName: string;
  seriesId: any[];
  seriesParent: string;
  pageContentEnabled: boolean;
}

